import { lazy } from "react";

const routes = [
  {
    path: "/state",
    element: lazy(() => import("../pages/State")),
  },
  {
    path: "/state/add",
    element: lazy(() => import("../pages/State/create")),
  },
  {
    path: "/state/edit/:id",
    element: lazy(() => import("../pages/State/edit")),
  },
];

export default routes;
